import { useEffect, useRef } from "react";

// Scroll-Reveal Hook
// `dep` triggert ein Re-Observe, wenn neue .reveal-Elemente nach Async-Load
// in den DOM kommen (z.B. Angebote/Kochkurse aus dem Backend).
export const useScrollReveal = (dep) => {
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -50px 0px" }
    );

    const elements = ref.current?.querySelectorAll(".reveal, .stagger-children");
    elements?.forEach((el) => observer.observe(el));

    // Fallback: wenn IntersectionObserver wegen Timing nicht greift,
    // alle Elemente, die bereits beim Mount im Viewport sind, sofort sichtbar machen.
    const reveal = () => {
      elements?.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add("visible");
      });
    };
    reveal();

    return () => observer.disconnect();
  }, [dep]);

  return ref;
};

export default useScrollReveal;
